<!--
 * @Descripttion: 动态表单渲染器
 * @version: 1.0
 * @Author: sakuya
 * @Date: 2021年9月22日09:26:25
 * @LastEditors:
 * @LastEditTime:
-->

<template>
	
	<!-- <el-skeleton v-if="renderLoading || isFor" animated />
	<div v-else-if="Object.keys(form).length==0">
		暂无配置信息
	</div> -->
	<el-table :data="config" v-model="form" stripe>
        <el-table-column label="配置名称" prop="key" width="150">
            <template #default="scope">
                <span>{{scope.row.info}}</span>
            </template>
        </el-table-column>
        <el-table-column label="配置值" prop="value" width="1000">
            <template #default="scope">
                <div v-if="scope.row.type=='upload'&&scope.row.upload_type==3">
                    <mn-upload-file v-model="form[scope.row.config_name]" accept=".png" :limit="10" :isObj="true">
                        <el-button type="primary" icon="el-icon-upload">上传附件</el-button>
                    </mn-upload-file>
                </div>
                <div v-else-if="scope.row.type=='file'">
                    <mn-upload-file v-model="form[scope.row.config_name]" accept=".png" :limit="1" :isObj="false">
                        <el-button type="primary" icon="el-icon-upload">上传附件</el-button>
                    </mn-upload-file>
                </div>
                <div v-else-if="scope.row.type=='files'">
                    <mn-upload-file v-model="form[scope.row.config_name]" accept=".png" :limit="10" :isObj="false">
                        <el-button type="primary" icon="el-icon-upload">上传附件</el-button>
                    </mn-upload-file>
                </div>
                <div v-else-if="scope.row.type=='imgs'||scope.row.type=='images'">
                    <mn-upload-multiple v-model="form[scope.row.config_name]" draggable :limit="10"></mn-upload-multiple>
                </div>
                <div v-else-if="scope.row.type=='img'||scope.row.type=='image'||scope.row.type=='upload'">
                    <mn-upload v-model="form[scope.row.config_name]"></mn-upload>
                </div>
                <el-radio-group v-else-if="scope.row.type=='radio'" v-model="form[scope.row.config_name]" style="margin-top: -5px;">
                    <el-radio v-for="(item,index) in scope.row.parameter" :key="index" :label="item.value" size="large">{{item.key}}</el-radio>
                </el-radio-group>
                <el-switch v-else-if="scope.row.type=='boolean'" v-model="form[scope.row.config_name]"></el-switch>
                <div v-else-if="scope.row.type=='upload'&&scope.row.files.type=='image/png'" style="align-items: center;display: flex;">
                    <mn-upload v-model="form[scope.row.config_name]" title="请上传图片"></mn-upload>
                </div>
                <div v-else-if="scope.row.type=='textarea'">
                    <el-input type="textarea" v-model="form[scope.row.config_name]" placeholder="请输入内容"></el-input>
                </div>
                <div v-else-if="scope.row.type=='number'">
                    <el-input-number v-model="form[scope.row.config_name]"></el-input-number>
                </div>
                <div v-else-if="scope.row.type=='editor'||scope.row.type=='r_text'||scope.row.type=='r_textarea'">
                    <mn-editor v-model="form[scope.row.config_name]" placeholder="请输入" :height="scope.row.high"></mn-editor>
                </div>
                <div v-else-if="scope.row.type=='checkbox'">
                    <el-checkbox-group v-model="form[scope.row.config_name]">
                        <el-checkbox v-for="(item,index) in scope.row.parameter" :key="index" :label="item.value">{{ item.key }}</el-checkbox>
                    </el-checkbox-group>
                </div>
                <div v-else-if="scope.row.type=='select'">
                    <el-select v-model="form[scope.row.config_name]" :multiple="false" placeholder="请选择" clearable filterable style="width: 100%;">
                        <el-option v-for="option in scope.row.parameter" :key="option.value" :label="option.key" :value="option.value"></el-option>
                    </el-select>
                </div>
                <div v-else-if="scope.row.type=='selects'">
                    <el-select v-model="form[scope.row.config_name]" :multiple="true" placeholder="请选择" clearable filterable style="width: 100%;">
                        <el-option v-for="option in scope.row.parameter" :key="option.value" :label="option.key" :value="option.value"></el-option>
                    </el-select>
                </div>
                <div v-else-if="scope.row.type=='password'">
                    <el-input v-model="form[scope.row.config_name]" :placeholder="scope.row.info" clearable autosize type="password" show-password></el-input>
                </div>
                <div v-else-if="scope.row.type=='date'">
                    <el-date-picker v-model="form[scope.row.config_name]" type="date" value-format="YYYY-MM-DD" :placeholder="scope.row.info || '请选择'"></el-date-picker>
                </div>
                <div v-else-if="scope.row.type=='datetime'">
                    <el-date-picker v-model="form[scope.row.config_name]" type="datetime" value-format="YYYY-MM-DD HH:mm:ss" :placeholder="scope.row.info || '请选择'"></el-date-picker>
                </div>
                <div v-else-if="scope.row.type=='time'">
                    <el-time-picker	v-model="form[scope.row.config_name]" arrow-control :placeholder="scope.row.info"/>
                </div>
                <div v-else-if="scope.row.type=='color'">
                    <el-color-picker v-model="form[scope.row.config_name]" />
                </div>
                <div v-else-if="scope.row.type=='datetimerange'">
                    <el-date-picker v-model="form[scope.row.config_name]" :shortcuts="shortcuts" type="datetimerange" value-format="YYYY-MM-DD HH:mm:ss" :placeholder="scope.row.info || '请选择'"></el-date-picker>
                </div>
                <div v-else-if="scope.row.type=='switch'">
                    <el-switch v-model="form[scope.row.config_name]" active-value="1" inactive-value="0"/>
                </div>
                <div v-else-if="scope.row.type=='array'">
                    <div>
                        <mn-array v-model="form[scope.row.config_name]" :isAdd="false"></mn-array>
                    </div>
                </div>
                <el-input v-else-if="scope.row.type=='text'" v-model="form[scope.row.config_name]" placeholder="请输入内容"></el-input>
                <template v-else>
                    <el-tag type="danger">[{{scope.row.type}}] Component not found</el-tag>
                </template>
                <div class="el-form-item-msg">
                    {{scope.row.desc}}
                </div>
            </template>
        </el-table-column>
        <el-table-column label="配置字段" prop="label_name" width="400" fixed="right">
            <template #default="scope">
                <span>{{scope.row.label_name}}</span>
            </template>
        </el-table-column>
        <el-table-column min-width="1"></el-table-column>
    </el-table>
    <slot>
        <el-button type="primary" @click="save()" style="margin-top: 20px;">更新配置</el-button>
    </slot>
</template>

<script>
	import http from "@/utils/request"
	import mnIconSelect from '@/components/mnIconSelect'
	import mnArray from '@/components/mnArrayNew'
	import { defineAsyncComponent } from 'vue'
	import { Base64 } from "js-base64"
	const mnEditor = defineAsyncComponent(() => import('@/components/mnEditor'))

	export default {
		props: {
			modelValue: { type: Object, default: () => {} },
			config: { type: Object, default: () => {} },
			loading: { type: Boolean, default: false },
			button:{ type:Boolean ,default : false } 
		},
        emits:['save','update:modelValue'],
		components: {
			mnEditor,
			mnIconSelect,
			mnArray
		},
		data() {
			return {
                shortcuts : [
					{
						text: '近一天',
						value: () => {
						const end = new Date()
						const start = new Date()
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
						return [start, end]
						},
					},
					{
						text: '近一周',
						value: () => {
						const end = new Date()
						const start = new Date()
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
						return [start, end]
						},
					},
					{
						text: '近一月',
						value: () => {
						const end = new Date()
						const start = new Date()
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
						return [start, end]
						},
					},
					{
						text: '近三个月',
						value: () => {
						const end = new Date()
						const start = new Date()
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
						return [start, end]
						},
					},
					{
						text: '近一年',
						value: () => {
						const end = new Date()
						const start = new Date()
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
						return [start, end]
						},
					},
				],
				form: {},
				renderLoading: false,
				isFor:true
			}
		},
		watch:{
			modelValue(){
				if(this.hasConfig){
					this.deepMerge(this.form, this.modelValue)
				}
			},
			config(){
				this.render()
			},
			form:{
				handler(val){
					this.$emit("update:modelValue", val)
				},
				deep: true
			}
		},
		computed: {
			hasConfig(){
				return Object.keys(this.config).length>0
			},
			hasValue(){
				return Object.keys(this.modelValue).length>0
			}
		},
		created() {

		},
		mounted() {
			if(this.hasConfig){
				this.render()
			}
		},
		methods: {
            save(){
                let config = this.config
                let a = {}
				for (const key in config) {
					if(config[key].type=='r_textarea'||config[key].type=='editor'||config[key].type=='r_text'){
						a[config[key].config_name] = Base64.encode(this.form[config[key].config_name]);
					}else{
						a[config[key].config_name] = this.form[config[key].config_name]
					}
				}
                this.$emit('save',a);
            },
			//构建form对象
			render() {
				this.isFor = true
                for (const key in this.config) {
                    this.form[this.config[key].config_name] = this.config[key].value
                }
				this.isFor = false
				if(this.hasValue){
					this.form = this.deepMerge(this.form, this.modelValue)
				}
				//this.getData()
			},
			//处理远程选项数据
			getData() {
				this.renderLoading = true
				var remoteData = []
				this.config.formItems.forEach((item) => {
					if(item.options && item.options.remote){
						var req = http.get(item.options.remote.api, item.options.remote.data).then(res=>{
							item.options.items = res.data
						})
						remoteData.push(req)
					}
				})
				Promise.all(remoteData).then(()=>{
					this.renderLoading = false
				})
			},
			//合并深结构对象
			deepMerge(obj1, obj2) {
				let key;
				for (key in obj2) {
					obj1[key] = obj1[key] && obj1[key].toString() === "[object Object]" && (obj2[key] && obj2[key].toString() === "[object Object]") ? this.deepMerge(obj1[key], obj2[key]) : (obj1[key] = obj2[key])
				}
				return obj1
				//return JSON.parse(JSON.stringify(obj1))
			},
			//处理动态隐藏
			hideHandle(item){
				if(item.hideHandle){
					const exp = eval(item.hideHandle.replace(/\$/g,"this.form"))
					return exp
				}
				return false
			},
			//处理动态必填
			rulesHandle(item){
				if(item.requiredHandle){
					const exp = eval(item.requiredHandle.replace(/\$/g,"this.form"))
					var requiredRule = item.rules.find(t => 'required' in t)
					requiredRule.required = exp
				}
				return item.rules
			},
			//数据验证
			validate(valid, obj){
				return this.$refs.form.validate(valid, obj)
			},
			scrollToField(prop){
				return this.$refs.form.scrollToField(prop)
			},
			resetFields(){
				return this.$refs.form.resetFields()
			},
			//提交
			submit(){
				this.$emit("submit", this.form)
			}
		}
	}
</script>

<style>
</style>
